export enum HttpResources {
  DashboardAppData = '/dashboard-api/dashboard/app-data/',
}
